"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentLeaderboardEntryWeek = exports.getAdditionalParticipantsRemainingAccounts = exports.instructionDataToTransactionInstruction = exports.getInstructionsFromVersionedTransaction = exports.getQuote = exports.getNftSellIx = exports.getSwapIx = exports.optimisticClaimWinnerNft = exports.optimisticDrawUserTicket = exports.optimisticHadespinRakeback = exports.optimisticFillHadespinLeaderboardWeekEntry = exports.optimisticFillHadespinLeaderboardEntry = exports.optimisticCreateUserRound = exports.optimisticCreateRound = exports.optimisticJoinRound = void 0;
const constants_1 = require("../../../constants");
const helpers_1 = require("../../../helpers");
const types_1 = require("../../../types");
const getMockContractUserRound_1 = require("../getters/getMockContractUserRound");
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const optimisticJoinRound = (args) => __awaiter(void 0, void 0, void 0, function* () {
    const feeNftAmount = Math.floor(((args.solInNftToDeposit) * args.roundSettings.feePercent) / constants_1.BASE_POINTS);
    const feeSolAmount = Math.floor(((args.solToDeposit) * args.roundSettings.feePercent) / constants_1.BASE_POINTS);
    const solInNftToDepositWithoutFee = args.solInNftToDeposit - feeNftAmount;
    const totalSolToDeposit = args.solToDeposit + solInNftToDepositWithoutFee;
    const feeAmount = feeNftAmount + feeSolAmount;
    if (args.round.roundState == types_1.RoundState.Uninitialized) {
        args.round = yield (0, exports.optimisticCreateRound)({
            round: args.round,
            roundPubKey: args.roundPubKey.toString(),
        });
        args.round.startedAt = (0, helpers_1.nowInSeconds)();
        args.round.roundNumber = args.roundNumber;
        args.round.roundState = types_1.RoundState.Open;
        args.round.roundEndsAt = (0, helpers_1.nowInSeconds)() + args.roundSettings.roundDuration;
        args.roundSettings.lastRoundEndsAt = args.round.roundEndsAt;
        //contract bid
        args.roundSettings.totalParticipants += 1;
        args.round.contractBid = args.roundSettings.contractBid;
        args.round.participants += 1;
        args.round.solAmount = args.roundSettings.contractBid;
        args.roundSettings.totalSolDeposited += args.roundSettings.contractBid;
    }
    const userRound = yield (0, exports.optimisticCreateUserRound)({
        roundSettings: args.roundSettings,
        solDeposited: totalSolToDeposit,
        round: args.round,
        userPubkey: args.userPubkey,
        userRoundPublicKey: args.userRoundPubKey,
        nftMint: args.nftMint,
    });
    const hadespinLeaderboardEntry = yield (0, exports.optimisticFillHadespinLeaderboardEntry)({
        hadespinLeaderboardEntry: args.hadespinLeaderboardEntry,
        solDeposited: args.solToDeposit,
        solInNftToDeposit: args.solInNftToDeposit,
        feeAmount: feeAmount,
        userPubkey: args.userPubkey,
    });
    const hadespinLeaderboardWeekEntry = yield (0, exports.optimisticFillHadespinLeaderboardWeekEntry)({
        hadespinLeaderboardWeekEntry: args.hadespinLeaderboardWeekEntry,
        solDeposited: args.solToDeposit,
        solInNftToDeposit: args.solInNftToDeposit,
        feeAmount: feeAmount,
        userPubkey: args.userPubkey,
    });
    const hadespinRakeback = yield (0, exports.optimisticHadespinRakeback)({
        solDeposited: args.solToDeposit,
        solInNftToDeposit: args.solInNftToDeposit,
        userPubkey: args.userPubkey,
        roundSetting: args.roundSettings,
        hadespinRakeback: args.hadespinRakeback,
    });
    args.round.participants++;
    args.round.solAmount += totalSolToDeposit;
    args.round.solInNftAmount += solInNftToDepositWithoutFee;
    args.round.feeAmount += feeAmount;
    args.round.lastTransactedAt = (0, helpers_1.nowInSeconds)();
    args.roundSettings.totalParticipants++;
    args.roundSettings.completedRounds = args.roundNumber;
    args.roundSettings.lastTransactedAt = (0, helpers_1.nowInSeconds)();
    args.roundSettings.totalFeeCollected += feeAmount;
    args.roundSettings.totalSolDeposited += totalSolToDeposit;
    const contractUserRound = yield (0, getMockContractUserRound_1.getMockContractUserRound)({
        contractBid: args.roundSettings.contractBid,
        roundPubkey: args.roundPubKey,
        programId: args.programId,
    });
    return {
        round: args.round,
        userRound: userRound,
        roundSettings: args.roundSettings,
        hadespinLeaderboardEntry: hadespinLeaderboardEntry,
        hadespinRakeback: hadespinRakeback,
        contractUserRound: contractUserRound,
        hadespinLeaderboardWeekEntry: hadespinLeaderboardWeekEntry,
    };
});
exports.optimisticJoinRound = optimisticJoinRound;
const optimisticCreateRound = (args) => __awaiter(void 0, void 0, void 0, function* () {
    return Object.assign(Object.assign({}, args.round), { roundState: types_1.RoundState.Initialized, publicKey: args.roundPubKey });
});
exports.optimisticCreateRound = optimisticCreateRound;
const optimisticCreateUserRound = (args) => __awaiter(void 0, void 0, void 0, function* () {
    const userRound = {
        depositedAt: (0, helpers_1.nowInSeconds)(),
        lastTransactedAt: (0, helpers_1.nowInSeconds)(),
        round: args.round.publicKey,
        startSolPosition: args.round.solAmount,
        solDeposited: args.solDeposited,
        user: args.userPubkey,
        publicKey: args.userRoundPublicKey,
        nftMint: args.nftMint,
        jackpotSolAmount: 0,
        jackpotClaimedAt: 0,
        jackpotClaimed: false,
        placeholderOne: 0,
        placeholderTwo: 0,
        placeholderThree: false,
        placeholderFour: false,
        placeholderFive: false,
    };
    return userRound;
});
exports.optimisticCreateUserRound = optimisticCreateUserRound;
const optimisticFillHadespinLeaderboardEntry = (args) => __awaiter(void 0, void 0, void 0, function* () {
    const newHadespinLeaderboardEntry = Object.assign(Object.assign({}, args.hadespinLeaderboardEntry), { lastTransactedAt: (0, helpers_1.nowInSeconds)(), totalNftDeposited: args.solInNftToDeposit == 0
            ? args.hadespinLeaderboardEntry.totalNftDeposited
            : args.hadespinLeaderboardEntry.totalNftDeposited + 1, user: args.userPubkey, totalSolInNftDeposited: args.hadespinLeaderboardEntry.totalNftDeposited + args.solInNftToDeposit, totalFeePayed: args.hadespinLeaderboardEntry.totalSolDeposited + args.feeAmount, totalSolDeposited: args.hadespinLeaderboardEntry.totalSolDeposited + args.solDeposited });
    return newHadespinLeaderboardEntry;
});
exports.optimisticFillHadespinLeaderboardEntry = optimisticFillHadespinLeaderboardEntry;
const optimisticFillHadespinLeaderboardWeekEntry = (args) => __awaiter(void 0, void 0, void 0, function* () {
    const newHadespinLeaderboardWeekEntry = Object.assign(Object.assign({}, args.hadespinLeaderboardWeekEntry), { lastTransactedAt: (0, helpers_1.nowInSeconds)(), totalNftDeposited: args.solInNftToDeposit == 0
            ? args.hadespinLeaderboardWeekEntry.totalNftDeposited : args.hadespinLeaderboardWeekEntry.totalNftDeposited + 1, user: args.userPubkey, totalSolInNftDeposited: args.hadespinLeaderboardWeekEntry.totalNftDeposited + args.solInNftToDeposit, totalFeePayed: args.hadespinLeaderboardWeekEntry.totalSolDeposited + args.feeAmount, totalSolDeposited: args.hadespinLeaderboardWeekEntry.totalSolDeposited + args.solDeposited, week: (0, exports.currentLeaderboardEntryWeek)() });
    return newHadespinLeaderboardWeekEntry;
});
exports.optimisticFillHadespinLeaderboardWeekEntry = optimisticFillHadespinLeaderboardWeekEntry;
const optimisticHadespinRakeback = (args) => __awaiter(void 0, void 0, void 0, function* () {
    const hadesToClaimAmount = Math.floor(((args.solDeposited + args.solInNftToDeposit) * args.roundSetting.rakebackHadesForSol) / web3_js_1.LAMPORTS_PER_SOL);
    const newHadespinRakeback = Object.assign(Object.assign({}, args.hadespinRakeback), { lastTransactedAt: (0, helpers_1.nowInSeconds)(), claimTimestamp: args.hadespinRakeback.claimTimestamp != 0
            ? args.hadespinRakeback.claimTimestamp
            : (0, helpers_1.nowInSeconds)() + constants_1.HADESPIN_RAKEBACK_TIMESTAMP, claimed: false, user: args.userPubkey, hadesToClaimAmount: args.hadespinRakeback.hadesToClaimAmount + hadesToClaimAmount });
    return newHadespinRakeback;
});
exports.optimisticHadespinRakeback = optimisticHadespinRakeback;
const optimisticDrawUserTicket = (args) => __awaiter(void 0, void 0, void 0, function* () {
    args.roundSettings.lastTransactedAt = (0, helpers_1.nowInSeconds)();
    args.round.winner = args.userRound.user;
    args.round.roundState = types_1.RoundState.Drawn;
    args.round.lastTransactedAt = (0, helpers_1.nowInSeconds)();
    args.userRound.lastTransactedAt = (0, helpers_1.nowInSeconds)();
    args.hadespinLeaderboardEntry.lastTransactedAt = (0, helpers_1.nowInSeconds)();
    args.hadespinLeaderboardEntry.totalSolWon += args.round.solAmount;
    args.hadespinLeaderboardWeekEntry.lastTransactedAt = (0, helpers_1.nowInSeconds)();
    args.hadespinLeaderboardWeekEntry.totalSolWon += args.round.solAmount;
    return {
        round: args.round,
        roundSettings: args.roundSettings,
        userRound: args.userRound,
        hadespinLeaderboardEntry: args.hadespinLeaderboardEntry,
        hadespinLeaderboardWeekEntry: args.hadespinLeaderboardWeekEntry,
    };
});
exports.optimisticDrawUserTicket = optimisticDrawUserTicket;
const optimisticClaimWinnerNft = (args) => __awaiter(void 0, void 0, void 0, function* () {
    args.roundSettings.lastTransactedAt = (0, helpers_1.nowInSeconds)();
    args.round.lastTransactedAt = (0, helpers_1.nowInSeconds)();
    args.userRoundWinner.lastTransactedAt = (0, helpers_1.nowInSeconds)();
    args.userRoundWithNft.lastTransactedAt = (0, helpers_1.nowInSeconds)();
    args.userRoundWithNft.nftMint = constants_1.EMPTY_PUBKEY.toBase58();
    if (args.round.solAmount == args.round.solInNftAmount && args.round.roundState == types_1.RoundState.Open) {
        args.round.winner = args.userRoundWinner.user;
        args.hadespinLeaderboardEntry.totalSolWon += args.round.solAmount;
        args.hadespinLeaderboardEntry.lastTransactedAt = (0, helpers_1.nowInSeconds)();
        args.round.roundState = types_1.RoundState.Drawn;
    }
    return {
        round: args.round,
        roundSettings: args.roundSettings,
        userRoundWinner: args.userRoundWinner,
        userRoundWithNft: args.userRoundWithNft,
        hadespinLeaderboardEntry: args.hadespinLeaderboardEntry,
    };
});
exports.optimisticClaimWinnerNft = optimisticClaimWinnerNft;
const getSwapIx = (user, quote) => __awaiter(void 0, void 0, void 0, function* () {
    const data = {
        quoteResponse: quote,
        userPublicKey: user.toBase58(),
    };
    return fetch(`${constants_1.API_ENDPOINT}/swap-instructions`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    }).then((response) => response.json());
});
exports.getSwapIx = getSwapIx;
const getNftSellIx = (user, minPriceLamports, mint, pool) => __awaiter(void 0, void 0, void 0, function* () {
    const data = {
        query: `query TswapSellNftTx(
      $minPriceLamports: Decimal!
      $mint: String!
      $pool: String!
      $seller: String!
      $sellerTokenAccount: String
    ) {
      tswapSellNftTx(
        minPriceLamports: $minPriceLamports
        mint: $mint
        pool: $pool
        seller: $seller
        sellerTokenAccount: $sellerTokenAccount
      ) {
        txs {
          lastValidBlockHeight
          tx
          txV0 # If this is present, use this!
        }
      }
    }`,
        variables: {
            seller: user.toBase58(),
            minPriceLamports: minPriceLamports.toString(),
            mint: mint.toBase58(),
            pool: pool.toBase58(),
            sellerTokenAccount: null,
        },
    };
    return fetch(`https://api.tensor.so/graphql`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-TENSOR-API-KEY': constants_1.TENSOR_API_KEY,
        },
        body: JSON.stringify(data),
    }).then((response) => response.json());
});
exports.getNftSellIx = getNftSellIx;
const getQuote = (fromMint, toMint, amount) => __awaiter(void 0, void 0, void 0, function* () {
    return fetch(`${constants_1.API_ENDPOINT}/quote?outputMint=${toMint.toBase58()}&inputMint=${fromMint.toBase58()}&amount=${amount}&swapMode=ExactOut&slippage=0.5`).then((response) => response.json());
});
exports.getQuote = getQuote;
const getInstructionsFromVersionedTransaction = (versionedTransaction) => __awaiter(void 0, void 0, void 0, function* () {
    const instructions = [];
    const messageKeys = versionedTransaction.message.getAccountKeys();
    versionedTransaction.message.compiledInstructions.forEach((compiledInstruction) => {
        const keys = [];
        compiledInstruction.accountKeyIndexes.forEach((keyIndex) => {
            const key = messageKeys.get(keyIndex);
            if (key) {
                keys.push({
                    pubkey: key,
                    isSigner: versionedTransaction.message.isAccountSigner(keyIndex),
                    isWritable: versionedTransaction.message.isAccountWritable(keyIndex),
                });
            }
        });
        const programId = messageKeys.get(compiledInstruction.programIdIndex);
        if (programId) {
            instructions.push(new web3_js_1.TransactionInstruction({
                keys,
                programId: programId,
                data: Buffer.from(compiledInstruction.data),
            }));
        }
    });
    return instructions;
});
exports.getInstructionsFromVersionedTransaction = getInstructionsFromVersionedTransaction;
const instructionDataToTransactionInstruction = (instructionPayload) => {
    if (instructionPayload === null) {
        return null;
    }
    return new web3_js_1.TransactionInstruction({
        programId: new web3_js_1.PublicKey(instructionPayload.programId),
        keys: instructionPayload.accounts.map((key) => ({
            pubkey: new web3_js_1.PublicKey(key.pubkey),
            isSigner: key.isSigner,
            isWritable: key.isWritable,
        })),
        data: Buffer.from(instructionPayload.data, 'base64'),
    });
};
exports.instructionDataToTransactionInstruction = instructionDataToTransactionInstruction;
const getAdditionalParticipantsRemainingAccounts = (args) => {
    const additionalParticipantsRemainingAccounts = constants_1.HADESPIN_ADDITIONAL_PARTICIPANTS_LIST.map((participant) => {
        const [userRound, userRoundBump] = anchor_1.web3.PublicKey.findProgramAddressSync([constants_1.ENCODER.encode(constants_1.USER_ROUND_PREFIX), participant.toBuffer(), constants_1.ENCODER.encode(args.roundNumber.toString())], args.programId);
        return [
            {
                pubkey: userRound,
                isSigner: false,
                isWritable: true,
            },
        ];
    }).flat();
    return additionalParticipantsRemainingAccounts;
};
exports.getAdditionalParticipantsRemainingAccounts = getAdditionalParticipantsRemainingAccounts;
const currentLeaderboardEntryWeek = () => Math.floor(((0, helpers_1.nowInSeconds)() - constants_1.HADESPIN_LEADERBOARD_START) / constants_1.HADESPIN_LEADERBOARD_WEEK_DURATION);
exports.currentLeaderboardEntryWeek = currentLeaderboardEntryWeek;
